import { Component } from '@angular/core';
import { ADVISORY_BOOKING_URL } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss'],
})
export class LandingHeaderComponent {
  readonly advisoryBookingUrl = ADVISORY_BOOKING_URL;
}
